import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><a parentName="p" {...{
        "href": "../overview.md"
      }}>{`@add-on-hlapi-sdk`}</a>{` / IRectangularNode`}</p>
    <h1 {...{
      "id": "interface-irectangularnode"
    }}>{`Interface: IRectangularNode`}</h1>
    <p>{`Interface for nodes with width and height properties.`}</p>
    <h2 {...{
      "id": "implemented-by"
    }}>{`Implemented by`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../classes/ArtboardNode.md"
        }}><inlineCode parentName="a">{`ArtboardNode`}</inlineCode></a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../classes/ImageRectangleNode.md"
        }}><inlineCode parentName="a">{`ImageRectangleNode`}</inlineCode></a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../classes/RectangleNode.md"
        }}><inlineCode parentName="a">{`RectangleNode`}</inlineCode></a></li>
    </ul>
    <h2 {...{
      "id": "table-of-contents"
    }}>{`Table of contents`}</h2>
    <h3 {...{
      "id": "properties"
    }}>{`Properties`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "IRectangularNode.md#height"
        }}>{`height`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "IRectangularNode.md#width"
        }}>{`width`}</a></li>
    </ul>
    <h2 {...{
      "id": "properties-1"
    }}>{`Properties`}</h2>
    <h3 {...{
      "id": "a-idheight-nameheighta-height"
    }}><a id="height" name="height"></a>{` height`}</h3>
    <p>{`• `}<strong parentName="p">{`height`}</strong>{`: `}<inlineCode parentName="p">{`number`}</inlineCode></p>
    <hr></hr>
    <h3 {...{
      "id": "a-idwidth-namewidtha-width"
    }}><a id="width" name="width"></a>{` width`}</h3>
    <p>{`• `}<strong parentName="p">{`width`}</strong>{`: `}<inlineCode parentName="p">{`number`}</inlineCode></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      